import { fetchEcomSetting } from '@gn-audio/core/api/site-settings/fetch-ecom-setting';
import { fetchPriceDisplaySetting } from '@gn-audio/core/api/site-settings/fetch-price-display-setting';
export var PriceDisplayStateDirective = [
    '$q',
    function ($q) {
        return {
            link: function ($scope, $element) {
                $q.when(fetchEcomSetting())
                    .then(function (ecomSetting) {
                    if (!ecomSetting.ecomEnabled) {
                        return;
                    }
                    $q.when(fetchPriceDisplaySetting())
                        .then(function (priceDisplaySetting) {
                        var cssClass = (priceDisplaySetting.priceDisplayOption || '').toLowerCase();
                        $element.addClass("price-" + cssClass);
                    });
                });
            },
            restrict: 'A',
        };
    },
];
